// Regras puras da tela de Tags do Kanban (/TagsKanban).
// Mockup: "Tags do Kanban (/TagsKanban) — colunas do board".
import { i18n } from "../../translate/i18n";

/**
 * Move um item de posição, devolvendo uma lista nova.
 * Índice fora da faixa devolve a lista intacta — um arraste solto fora da
 * área chega assim.
 */
export const reordena = (lista = [], de, para) => {
  if (
    !Array.isArray(lista) ||
    de === para ||
    de < 0 ||
    para < 0 ||
    de >= lista.length ||
    para >= lista.length
  ) {
    return lista;
  }
  const copia = [...lista];
  const [movido] = copia.splice(de, 1);
  copia.splice(para, 0, movido);
  return copia;
};

// Payload do PUT /tags/order: só os ids, na ordem da tela.
export const payloadOrdem = (lista = []) => lista.map((t) => t.id);

export const totalTickets = (tags = []) =>
  tags.reduce((soma, t) => soma + (Number(t.ticketsCount) || 0), 0);

/**
 * Largura da coluna na prévia do board, proporcional ao volume de tickets.
 * Piso de 8% para uma coluna vazia ainda aparecer na prévia.
 */
export const larguraPrevia = (tag, tags = []) => {
  const total = totalTickets(tags);
  if (total <= 0) return 100 / Math.max(1, tags.length);
  const pct = ((Number(tag?.ticketsCount) || 0) / total) * 100;
  return Math.max(8, pct);
};

export const rotuloTickets = (quantidade) => {
  const n = Number(quantidade) || 0;
  return i18n.t(n === 1 ? "aeros.kanbanTags.ticketOne" : "aeros.kanbanTags.tickets", {
    count: n,
  });
};
